var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper registration" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c(
        "div",
        { staticClass: "auth-wrapper__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("lang-select", { staticClass: "set-language" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              class: {
                "login-container": !_vm.isMobile,
                "login-container-mobile": _vm.isMobile
              },
              attrs: {
                model: _vm.model,
                rules: _vm.rules,
                "label-position": "left",
                "label-width": "0px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "email" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      disabled: !!_vm.defaultEmail,
                      type: "text",
                      "auto-complete": "off",
                      placeholder: _vm.$t("auth.registerManager.email")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "auto-complete": "off",
                      placeholder: _vm.$t("auth.registerManager.password")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.password,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "password", $$v)
                      },
                      expression: "model.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: { placeholder: _vm.$t("auth.registerManager.name") },
                    model: {
                      value: _vm.model.name,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "lastName" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      placeholder: _vm.$t("auth.registerManager.lastName")
                    },
                    model: {
                      value: _vm.model.lastName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "lastName", $$v)
                      },
                      expression: "model.lastName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "phone" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      placeholder: _vm.$t("auth.registerManager.phone")
                    },
                    model: {
                      value: _vm.model.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.checked,
                          callback: function($$v) {
                            _vm.checked = $$v
                          },
                          expression: "checked"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("auth.registerManager.accept")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: { type: "text", to: { name: "privacyPolicy" } }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("auth.registerManager.privacyPolicy"))
                        )
                      ]
                    )
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "primary",
                        loading: _vm.loading,
                        disabled: !_vm.checked
                      },
                      on: { click: _vm.submit }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("auth.registerManager.createAccount"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "text-center" },
                [
                  _c("router-link", { attrs: { to: { name: "login" } } }, [
                    _vm._v(_vm._s(_vm.$t("auth.registerManager.cancel")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53bfe5cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53bfe5cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/registration/registrationManager.vue
// module id = null
// module chunks = 